export default {
	tour: {
		footer: {
			skip: 'Skip tour',
			back: 'Back',
			next: 'Next',
			done: 'Done',
			wait: 'Please wait…',
		},
	},
}
